import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnChanges, OnDestroy, Renderer2 } from '@angular/core';
import { SummaryService } from '../services/summary.service';
import { Summary, SummarySortOption, SummaryColumn, CardImage, SubDetail, ValueSelection, SummaryPage, StackCardBasic, SummaryFunctions, SummaryActions } from '../objects/SummaryObject';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { TokenManager } from '../Globals';
import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { Toaster } from '../objects/ToasterObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { trigger, state, style, animate, transition} from '@angular/animations';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTable } from '@angular/material';
import { of, Subscription, Subject, BehaviorSubject } from 'rxjs'
import { Observable } from 'rxjs/Rx'
import { ThemeSettingService } from '../services/theme-setting.service';
import { VirtualScrollerComponent, IPageInfo } from 'ngx-virtual-scroller';
import { ConfirmationService } from '../services/confirmation.service';
import { WorkspaceService } from '../services/workspace.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { MyTreeNode } from '../objects/TreeviewObject';
import { ThemeSetting } from '../objects/ThemeObject';
import { LoadingSummaryService } from '../services/loading-summary.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { HeaderService } from '../services/header.service';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { Action, DetailProperty, AttachmentSummary } from '../objects/DetailObject';
import { AttachmentService } from '../services/attachment.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { debounceTime } from 'rxjs/operators';
import { EnvService } from '../env.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { SidePopupService } from '../services/side-popup.service';
import { FileErrorType } from '../attachment/attachment.component';

@Component({
  selector: 'app-sub-summary',
  templateUrl: './sub-summary.component.html',
  styleUrls: ['./sub-summary.component.css'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1
      })),
      state('closed', style({
        opacity: 0
      })),
      transition('open => closed', [
        animate('50ms')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
    trigger('toggleHeight', [
      state('in', style({
        height: '*',
        overflow: 'hidden'
      })),
      state('out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})

export class SubSummaryComponent implements OnChanges, OnInit, AfterViewInit, OnDestroy {
  
  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;
  @ViewChild(VirtualScrollerComponent) private virtualScroller: VirtualScrollerComponent;
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild('scroll') tableScroller: any;
  @ViewChild(InfiniteScrollDirective) scrollBar: InfiniteScrollDirective;
  @ViewChild('tableContainer') public tableContainer: ElementRef;
  collapsed:boolean;
  @Input() private isDataSet: boolean = false;
  @Input() private isSubSummary: boolean = false;
  @Input() private groupId:string;
  @Input() private groupType:string;
  @Input() private propertyId:string;
  @Input() private parentType:string;
  @Input() private parentId:string;
  @Input() filledSpace:number = 0;
  @Input() isSummaryPopup: boolean;
  @Input() groupFormat: string = '';
  @Input() isInlineControls: boolean;
  @Input() isPreview: boolean = false;
  @Input() isChartTable: boolean = false;
  @Input() autoRefresh: boolean = false;
  @Input() noRelation: boolean = false;
  @Input() displaySummary: boolean = true;
  @Input() fromBroadcast: boolean = false;
  @Input() set updateSummary(update: boolean){
    if (update){
      this.refreshCard();
    }
  }
  @Input() set showSummary(showSummary:boolean){
    if(showSummary && !this.summary){
      this.refreshCard();
    }
    else if(!showSummary){
      this.collapsed = true;
      this.setCollapsed.emit(true);
    }
    else{
      this.collapsed = false;
      this.setCollapsed.emit(false);
    }
  }
  @Input() documentName:string;
  @Input() set setSelectedDetailId(id:string){ 
    this.selectedItemId = id;
  }
  @Input() set setForceRefresh(isRefresh:boolean){
    this.refreshCard();
  }
  @Input() set setSearchKeyword(keyword:string){
    if (keyword != "#trigger"){ // no user should know this secretrecipe
      if(this.componentId){
        this.keyword = keyword.trim();
        this.isGetSummary = true;
        if (this.keyword == ''){
          this.summaryService.clearKeyword(this.componentId).subscribe(result=> {
            if(result == '1'){
              this.refreshCard();
            }
          });
        }
        else {
          this.searchByKeyword(this.keyword);
        }
      }
    }
  }
  @Input() set changeSortOption(sortOption:SummarySortOption){ 
    if(sortOption){
      this.summaryService.changeSortType(this.componentId, sortOption.SortField).subscribe(result=> {
        if(result){
          if(result == '1'){
            this.refreshCard();
          }
        }
      });
    }   
  }
  @Input() set changeSortDirection(isAscending:boolean){
    if(isAscending != null){ 
      // this.isBusy = true;
      if (this.componentId){
        this.summaryService.changeSortDirection(this.componentId, isAscending.toString()).subscribe(result=> {
          if(result){
            if(result == '1'){
              this.refreshCard();
            }
            else {
              this.isBusy = false;
            }
          }
        });
      }
      
    }
  }

  @Input() set setPageSize(pageSize:string){ 
    this.newPageSize(pageSize);
  }
  @Input() set nextPageTrigger(update:boolean){ 
    this.nextSlidePage();
  }
  @Input() set prevPageTrigger(update:boolean){ 
    this.prevSlidePage();
  }
  @Input() set changePageTrigger(selectedPage: number){
    this.changePage(selectedPage);
  }

  @Input() set componentIdSet(componentId:any){
    if (componentId){
      if (componentId == 1){ // default input to cancel loading
        this.animate = true;
        this.isBusy = false;
      }
      else{
        this.errorMessage = "";
        this.componentId = componentId;
        this.refreshCard();
      }
    }
    else if (componentId == 0){
      this.animate = false;
      this.isBusy = true;
    }
  }
  @Input() set customInputSet(value:string){
    if (value)
    {
      this.summaryService.UserSelectionInput(this.componentId, value).subscribe(result=>{
        this.refreshCard();
      })
    }
  }
  @Input() set changeLayout(changeLayout:string){
    if(changeLayout){
      this.summaryService.changeSummaryLayout(this.componentId).subscribe(result => {
        if (result == '1'){
          this.refreshCard();
        }
      })
    }
  }

  @Input() set parentScroll(position: number){
    if (this.summaryLayout == "CARDMESSAGES"){
      this.nextPage.next();
    }
  }

  @Input() set setExpandSummary(expandSummary: boolean){
    this.isFromExpandSummary = expandSummary;
  }

  @Output() subSelectedId = new EventEmitter<any>();
  @Output() subCardSelectedId = new EventEmitter<string>();
  @Output() popupSelectedId = new EventEmitter<string>();
  @Output() sortOptions = new EventEmitter<SummarySortOption[]>();
  @Output() summaryPage = new EventEmitter<SummaryPage>();
  @Output() summaryTotalRows = new EventEmitter<number>();
  @Output() openPopup = new EventEmitter<string>();
  @Output() setSummaryName = new EventEmitter<string>();
  @Output() setPopupTitle = new EventEmitter<string>();
  @Output() hidePopup = new EventEmitter<boolean>();
  @Output() isDualView = new EventEmitter<boolean>();
  @Output() isCardView = new EventEmitter<boolean>();
  @Output() fetching = new EventEmitter<boolean>();
  @Output() setCollapsed = new EventEmitter<boolean>();
  @Output() showSummarySettings = new EventEmitter<boolean>();
  @Output() isCardImage = new EventEmitter<boolean>();

  public readonly isLoadingAsync: BehaviorSubject<boolean> = new BehaviorSubject(false);
  nextPage: Subject<any> = new Subject();
  summary:Summary;
  isBusy:boolean = false;
  isCardBusy:boolean = false;
  errorMessage:string;
  imageId: string[];
  imageObject : any[];
  nextImageObject: any[];
  nextImageId: any[];
  modalRef: BsModalRef;
  ticks = 0;
  itemSize = 10;
  summaryLength = 10;
  private componentId :string;
  private animate:boolean = true;
  private isPerformWorkflow: boolean = false;
  private selectedItemId:string;
  summaryLayout:string;
  private idColumn:string;
  private keyword:string;
  private indicatorColor: string;
  private sortOptionList:SummarySortOption[];
  private summaryCardImage: CardImage[];
  private isFav: boolean = false;
  private onGoing : boolean = false;
  private subDetailId:string;
  private gettingDetail : boolean = false;
  private visibleColumns :SummaryColumn[];
  private visibleColumnNames: string[];
  private showSaveIcon: string;
  private showSaveIconLabel: string;
  private currentImage: Blob;
  private showAll : boolean = true;
  private dropdownList = new Object();
  private selectedDropdownValue = new Object();
  private isImageLoad: boolean = true;
  private noLoading: boolean = false;
  private summaryData:any;
  private cloneSummaryData: any;
  private stackCardBasic:StackCardBasic[];
  private editablecardUrl:any;
  private totalRatioWidth:number = 0;
  private treeNodes:MyTreeNode[] = [];
  private loaderConfig: ThemeSetting;
  private mark: string;
  private markList = [];
  private isFetching:boolean = false;
  private isFiltering:boolean = false;
  private isFilteredSummary: boolean = false;
  private tableHasData: boolean = true;
  private emitSelectedId:boolean = true;
  private previousComponentId: string;
  private parentArray = [];
  private columnsLength: number;
  private selectedArray = [];
  private isGetSummary: boolean = false;
  private fixLoader: boolean = false;
  private showSummaryMenu:boolean = false;
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;
  private sub5: Subscription;
  private sub6: Subscription;
  private cellsSelected = [];
  private filterKeyword: string;
  private isLoadingInline: boolean = false;
  private timer;
  private userInput: string;
  private footerButton: SummaryActions;
  private visibleSummaryActions: SummaryActions[] = [];
  private selectedRowCount: number = 0;
  private allSelectedIds: string[] = [];
  private footerBtnInstance: () => void;
  private currentCardImage: CardImage[];
  private maxFileSizeKb = 10000;  
  private allowedFormats: string[] = ["pdf", "png", "jpg", "docx", "doc", "xlsx", "xls", "ppt", "pptx", "pdf", "jpg", "jpeg", "gif", "png", "bmp", 
  "dtsconfig", "xml", "dtsx", "mdd", "mcf", "txt", "csv", "zip", "rar", "eml"];  
  private summaryFiles = [];
  private rowsToUpdate = [];
  private showNoLoader: boolean = false;
  private rowDataChanged = new Subject<any>();
  allowedFormatsString: string;
  acceptFormatString: string;
  actionSaveDisplay: string;
  isBreakdownSummary: boolean = false;
  activeSort: string;
  activeSortDirection: string;
  hasActionRequiresSelection: boolean = false;
  nextPageLoaded: boolean = false;
  isExpandSummary: boolean = false
  separator: any;
  isSelectAll: boolean;
  currentSummaryData: any;
  isUploading: boolean;
  isUploadError: boolean;
  bsConfig: Partial<BsDatepickerConfig> = Object.assign({}, { containerClass: 'theme-blue' });
  swiperIndex = 0;
  currentDataFile = [];
  isFromExpandSummary: boolean = false;
  public actions :any;
  private indexSet: boolean = false;
  public viewerOptions: any = {
    navbar: false,
    movable: false,
    toolbar: {
      reset: 4,
      prev: 4,
      play: {
        show: 4,
        size: 'large',
      },
      next: 4,
      flipHorizontal: 4,
      flipVertical: 4,
    }
  };
  
  public config: ToasterConfig = 
  new ToasterConfig({
    animation: 'fade',
    timeout: 30000,
    tapToDismiss : false,
    mouseoverTimerStop: true
  });
  
  public swiperConfig: SwiperConfigInterface = {
    direction: 'vertical',
    slidesPerView: 4,
    navigation: true,
    pagination: false,
    mousewheel: true,
    breakpoints: {
      // when window width is <= 480px
      380: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      }
    }
  };

  treeControl: NestedTreeControl<MyTreeNode>;
  treeDataSource: MatTreeNestedDataSource<MyTreeNode>;
  
  constructor(
    private route:ActivatedRoute, 
    private globals:Globals, 
    private summaryService:SummaryService, 
    private router:Router,
    private tokenManager:TokenManager,
    private toasterService: ToasterService,
    private toasterMessageService:ToasterMessageService,
    private themeSettingService: ThemeSettingService,
    private confirmationService: ConfirmationService,
    private workspaceService:WorkspaceService,
    private attachmentService: AttachmentService,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
    private loadingSummaryService: LoadingSummaryService,
    private contextMenuService: ContextMenuService,
    private workflowReturnService: WorkflowReturnService,
    private headerService: HeaderService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private env: EnvService,
    private sidePopupService: SidePopupService
  ) {
    this.treeControl = new NestedTreeControl<MyTreeNode>(this.makeGetChildrenFunction());
    this.treeDataSource = new MatTreeNestedDataSource();
    this.treeDataSource.data = this.treeNodes;
    this.sub1 = this.workspaceService.currentParentIdChanged$.subscribe(id => {
      if (this.componentId == id){
        this.emitSelectedId = false;
        this.isBusy = true;
        this.refreshCard();
      }
    });

    this.sub2 = this.workflowReturnService.isLoadingHomeChanged.subscribe(result => {
      if (result) {
        this.isBusy = true;
      }
      else{
        this.isBusy = false;
      }
    });
  }

  hasChildren = (_: number, node: MyTreeNode) => {
    return node.children && node.children.length > 0;
  }

  selectTree($event){
    if ($event){
      this.isBusy = true;
      this.animate = false;
      this.summaryService.selectItem(this.componentId, $event.id).subscribe(result=>{
        this.handleWorkflowReturn(result);
        this.isBusy = false;
        this.animate = true;
      });
    }
  }

  searchByKeyword(keyword: string){
    this.summaryService.searchKeyword(this.componentId, keyword).subscribe(result=> {
      if(result == '1'){
        this.refreshCard();
      }
    }, error => {
      this.loadingSummaryService.setLoading(false);
    });
  }

  onSelectFile(event, summaryRowId) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        var tree = <FileReader>event.target;
        this.editablecardUrl.find(x=> x.id == summaryRowId).ImageURL = tree.result;
        //this.url = tree.result;
      }
    }
  }

  
  triggerExport(){
     this.confirmationService.confirm(
        "Export " + this.summary.SummaryName,
        "<p>Are you sure you want to export all data from this summary? <br/> Please note that the data exported will be sent through the email.</p>",
        ["NO", "YES"], false)
        .subscribe((respond) => {
          if (respond.answer == "YES"){
            this.summaryService.requestEmailSummary(this.componentId).subscribe(result => {
              if (result){
                if (result.toLowerCase() == "true"){
                  this.toasterMessageService.popToast("Info", "You have requested to export data for " + this.summary.SummaryName + ". Once the request is ready, you will receive a notification.", "info");
                  //show message or something to the user
                }
              }
            })
          }
      });
  }

  getImageURL(id){
    return this.editablecardUrl.find(x => x.id == id).ImageURL;
  }

  viewAllSummary(){
    var pageSize = "1000";
    // if (this.showAll){
    //   pageSize = "0"; 
    // }
    this.showAll = !this.showAll;
    this.summaryService.changePageSize(this.componentId, pageSize).subscribe(result=> {
      if(result){
        if(result == '1'){
          this.refreshCard();
        }
      }
    });
  }

  newPageSize(pageSize: string) {
    if(this.componentId){
      if(pageSize){
        this.summaryService.changePageSize(this.componentId, pageSize).subscribe(result=> {
          if(result){
            if(result == '1'){
              this.refreshCard();
            }
          }
        });
      }
    }
  }

  prevSlidePage() {
    if(this.componentId){
      this.isBusy = true;
      this.summaryService.previousPage(this.componentId).subscribe(result=> {
        this.noLoading = true;
        this.refreshCard();
      });
    }
  }

  nextSlidePage() {
    if(this.componentId){
      this.isBusy = true;
      this.summaryService.nextPage(this.componentId).subscribe(result=> {
        this.noLoading = true;
        this.refreshCard();
      });
    }
  }

  get pageNumbers(): (number | string)[] {
    const pages = [];
    const totalPages = this.summary.AvailablePages;
    const currentPage = this.summary.CurrentPage;

    if (totalPages < 5) {
      // If total pages are 5 or less, show all
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show the first page
      pages.push(1);

      // Show ellipsis if the current page is greater than 2
      if (currentPage > 4) {
        pages.push('...');
      }

      // Show pages around the current page
      const startPage = Math.max(2, currentPage - 2);
      const endPage = Math.min(totalPages - 1, currentPage + 2);
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Show ellipsis if the current page is less than total pages - 2
      if (currentPage < totalPages - 2) {
        pages.push('...');
      }

      // Always show the last page
      pages.push(totalPages);
    }

    return pages;
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.summary.AvailablePages) {
      
      if(this.componentId){
        this.isBusy = true;
        this.summaryService.changePage(this.componentId, page).subscribe(result=> {
          this.noLoading = true;
          this.refreshCard();
        });
      }

    }
  }

  changePage(selectedPage: number) {
    this.isBusy = true;
    if (this.componentId && !this.onGoing){
      this.onGoing = true;
      this.summaryService.changePage(this.componentId, selectedPage).subscribe(result => {
          this.refreshCard();
          this.isBusy = false;
          this.onGoing = false;
      });
    }
  }

  selectItem(selectedId:string, forceSelect:boolean = false, showLoading: boolean = false):void{
    // this.tokenManager.store("BRNSummarySelectedItem:"+this.componentId, selectedId);
    if(this.parentType){
      this.emitSelectedItem(selectedId);
      this.selectedItemId = selectedId;
    }else{
      this.selectedItemId = selectedId;
      if (!this.isSubSummary) this.subSelectedId.emit(0);
      this.isBusy = showLoading;
      this.animate = !showLoading;
      this.summaryService.selectItem(this.componentId, selectedId).subscribe(result => {
        this.handleWorkflowReturn(result, true);        
        this.handleSelectItem(result, forceSelect);

      }, error => {
        this.isBusy = false;
      this.animate = true;
        this.subSelectedId.emit(1);
      });
    }
  }

  private handleSelectItem(result, forceSelect: boolean){
    var wf = JSON.parse(result);

    if (wf.ReturnType == 3 || wf.ReturnType == 4){
      var selectedId:string = wf.Arguments[0];

      var isSubDetail = false;
      var isEmit = false;
  
      this.summary.Columns.forEach(column => {
        if (column.ViewColumnType == "SUBDETAIL"){
          this.subDetailId = selectedId;
          isSubDetail = true;
        }
      })
      
      if (!isSubDetail){
        if (forceSelect){
          isEmit = true;
          this.emitSelectedItem(selectedId);
        }
        else{
          // if (this.previousComponentId != this.componentId){
            if (this.emitSelectedId){
              isEmit = true;
              this.emitSelectedItem(selectedId);
            }
          // }
        }
      }
    
      if (!isEmit && !this.isSubSummary){
        this.subSelectedId.emit(1);
      }
      // this is to check whether select item is from a new summary card or existing
      this.previousComponentId = this.componentId;
    }
  }

  private makeGetChildrenFunction() {
    return node => of(node.children)
  }

  popToast(title: string, body: string, type:string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.toasterMessageService.pushToaster(toaster);
      } 
    };
    this.toasterService.pop(toast);
  }

  checkIfHasError(id: string): boolean{
    var noError = true;
    if (id){
      if(id.startsWith("ERROR:")){
        noError = false;
        this.componentId = "";
        this.errorMessage = id.substr(6, id.length - 1);
        setTimeout(() => {
          this.isCardBusy = false;
          this.isBusy = false;
        });
      }
      else{
        noError = true;
      }
    }
    return noError;
  }

  refreshCard(selectItem:boolean = true):void{
    if (this.checkIfHasError(this.componentId)){
      if (!this.noLoading){
        this.delayUpdateVariable(true);
      }

      if (!this.showNoLoader) this.fixLoader = true;
      if(this.componentId && this.globals.Session){
        this.summaryService.getSummary(this.componentId).subscribe(result=> {
          this.isGetSummary = false;
          this.fixLoader = false;
          this.isFetching = false;
          this.currentDataFile = [];
          this.summaryService.setEnableSearch(true);
          this.summary = JSON.parse(result);

          this.currentSummaryData = this.summary.Data;
          this.storeIfSelectAll();
          if (this.summary){
            if (selectItem){
              this.summaryService.getSelectedId(this.componentId).subscribe(selectedId=>{
                if(selectedId){
                  this.selectItem(selectedId);
                }
                else{
                  this.previousComponentId = this.componentId;
                }
              });
            }
            this.setSummaryName.emit(this.summary.SummaryName);
            this.setPopupTitle.emit(this.summary.HeaderText);
            this.summaryTotalRows.emit(this.summary.TotalRows);
            this.isDualView.emit(this.summary.IsDualView);
            this.loadingSummaryService.setLoading(false);

            this.sortSummaryActions();
            this.handleSummarySelection();
            this.handleSummaryFunctions();
            this.handleActionSave();
            this.visibleSummaryActions = this.summary.Actions.filter(x => !x.IsHidden);
            
            if(this.summary.SystemSummaryName){
              this.summary.SummaryClass = this.summary.SystemSummaryName.replace(/\s/g, "_");
            }

            this.summaryPage.emit({currentPage: this.summary.CurrentPage, availablePage: this.summary.AvailablePages});
            if(this.summary.CardLayoutProperties.length > 0){
              this.summaryLayout = this.summary.CardLayoutProperties[0].LayoutType.toUpperCase();
              this.idColumn = this.summary.CardLayoutProperties.find(x=> x.CardProperty.toUpperCase() == "ID").PropertyName;
              this.isCardView.emit(true);
              if (this.summaryLayout == "CARDIMAGE") this.isCardImage.emit(true);
            } else {

              if (this.summary.SummaryDisplay == "TABLEADVANCED"){
                this.summaryLayout = "TABLEADVANCED";
              }
              else{
                this.summaryLayout = "TABLE";  
                this.idColumn = this.summary.Columns.find(x => x.IsID).PropertyName;
                if (this.isFiltering){
                  this.isFiltering = false;
                }
                if (this.summary.Data.length > 0) {
                  this.tableHasData = true;
                }
                else {
                  this.tableHasData = false;
                  // var dummyData = {data: "no data"};
                  // this.summary.Data.push(dummyData);
                }
              }

              this.isCardView.emit(false);
              
            }

            if (this.isInlineControls){
              //this.handleInlineControls();
            }

            this.summary.Data.forEach(data => {
              this.summary.Columns.forEach(column => {
                if (column.ViewColumnType == "COMBOBOX"){
                  if (column.AdditionalInfo){
                    column.AdditionalInfo.forEach(info => {
                      info.SelectionValue = info.SelectionValue.toLowerCase();
                    });
                  }
                }
                else if (column.ViewColumnType == "FILE"){
                  // if (data[column.PropertyName]){
                  //   this.attachmentService.downloadFile(data[column.PropertyName].split('|')[0]).subscribe(result=>{
                  //     data['fileURL'] = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(result));
                  //     this.currentDataFile.push({id: data[this.idColumn], fileUrl: data['fileURL']});
                  //   });
                  // }
                }
                else if (column.ViewColumnType == "FILEUPLOAD"){
                  // if (data[column.PropertyName]){
                    this.getFileList(data, column);
                    this.getFilesSettings();
                  // }
                }
                else if (column.ViewColumnType){
                  if (column.AdditionalParameter){
                    if(column.AdditionalParameter.indexOf('Expand') > -1){
                      this.isBreakdownSummary = true;
                    }
                  }
                }
              });
            });
  
            this.summaryData = this.sortSummaryData(this.summary.Data);
            this.cloneSummaryData = JSON.parse(JSON.stringify(this.summaryData));

            this.getVisibleColumns();
            this.totalRatioWidth = 0;
            this.visibleColumns.forEach(element => {
              this.totalRatioWidth = this.totalRatioWidth + element.WidthWeight;
            });

            if (this.isPreview) this.summary.SelectionType = null;
            if (this.isChartTable) {
              let timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
              if (this.sub5) this.sub5.unsubscribe();
              this.sub5 = timer.subscribe(t => this.checkIfSummaryHasUpdate());
            }
            
            this.handleHeaderAndFooter();
            this.constructObjectByLayout();
            this.summaryData = this.parseValueForMultiCombobox(this.summary, this.summaryData);
            this.sortOptionList = this.summary.SortOptions;
            this.sortOptions.emit(this.summary.SortOptions);
            if (this.isChartTable && this.previousComponentId == this.componentId){
              this.summaryService.setSummaryUpdate(true);
            }
          }
  
          this.delayUpdateVariable(false);
          this.autoRefresh = false;
          this.collapsed = false;
          this.showNoLoader = false;
          this.setCollapsed.emit(false);
        }, error => {
          this.isBusy = false
        });
      }
      else if(this.parentId && this.groupId){
        this.summaryService.getNewSummaryFromDetail(this.parentId, this.groupId, this.noRelation).subscribe(result=>{
          if(result.startsWith("ERROR:")){
            this.errorMessage = result.substr(6, result.length - 1);
            this.removeCardLoading();
          }else{
            this.componentId = result;
            if (this.componentId){
              this.refreshCard();
            }
            else{
              this.removeCardLoading();
            }
          }
        })
      }
      else if(this.parentId && this.propertyId){
        this.summaryService.getDataSetSummaryFromDetail(this.parentId, this.propertyId).subscribe(result=>{
          if(result.startsWith("ERROR:")){
            this.errorMessage = result.substr(6, result.length - 1);
            this.removeCardLoading();
          }else{
            this.componentId = result;
            if (this.componentId){
              this.refreshCard();
            }
            else{
              this.removeCardLoading();
            }
          }
        })
      }
    }
    
  }

  refreshCardCurrentPage(selectItem:boolean = true, currentPage: number):void {
    if(this.componentId){
      this.isBusy = true;
      this.summaryService.changePage(this.componentId,currentPage).subscribe(result=> {
        this.noLoading = true;
        this.refreshCard();
      });
    }
  }

  downloadFileCol(row, column){
    this.isBusy = true;
    this.animate = false;
    this.attachmentService.downloadFile(row[column.PropertyName].split('|')[0]).subscribe(result=>{
      // row['fileURL'] = this.sanitizer.bypassSecurityTrustHtml(window.URL.createObjectURL(result));
      // this.currentDataFile.push({id: row[this.idColumn], fileUrl: row['fileURL']});
      this.isBusy = false;
      this.animate = true;
      this.downloadFile(result, row[column.PropertyName].split('|')[1]);
    }, error => {
      this.isBusy = false;
      this.animate = true;
    });
  }

  onMatTableScroll(e){
    if (this.summary.CurrentPage == this.summary.AvailablePages || this.isExpandSummary) return;
    const tableViewHeight = e.target.offsetHeight // viewport: ~500px
    const tableScrollHeight = e.target.scrollHeight // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled

    // If the user has scrolled within 200px of the bottom, add more data
    const buffer = 200;

    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit) {
      if (!this.isFetching) {
        this.isFetching = true;
        this.fetching.emit(true);
        this.fetchNextChunk().then(chunk => {
          // this.summaryData = chunk;
          this.formatNextData(chunk);
          this.currentSummaryData = this.summaryData;
          this.cloneSummaryData = JSON.parse(JSON.stringify(this.summaryData));
          this.storeIfSelectAll();  
          this.isFetching = false;
          this.fetching.emit(false);
          this.loadMoreImages();
        }, () => this.isFetching = false);
      }
    }
  }

  loopGetNextSummary(){
    this.isFetching = true;
    this.fetching.emit(true);
    this.fetchNextChunk().then(chunk => {
      // this.summaryData = chunk;
      this.formatNextData(chunk);
      this.currentSummaryData = this.summaryData;
      this.cloneSummaryData = JSON.parse(JSON.stringify(this.summaryData));
      this.storeIfSelectAll();  
      this.isFetching = false;
      this.fetching.emit(false);
      this.loadMoreImages();

        if (this.tableContainer && this.isFromExpandSummary){
          if (this.tableContainer.nativeElement.scrollHeight <= this.tableContainer.nativeElement.clientHeight){
            // means no scrollbar
            if (this.summary.CurrentPage < this.summary.AvailablePages){
              this.loopGetNextSummary();
            }
          }
        }
      
    }, () => this.isFetching = false);
  }

  formatNextData(summaryData: any){
    summaryData.forEach(data => {
      this.summary.Columns.forEach(column => {
        if (column.ViewColumnType == "COMBOBOX"){
          if (column.AdditionalInfo){
            column.AdditionalInfo.forEach(info => {
              info.SelectionValue = info.SelectionValue.toLowerCase();
            });
          }
        }
        else if (column.ViewColumnType == "FILE"){
          // if (data[column.PropertyName]){
          //   if (this.currentDataFile.find(x => x.id == data[this.idColumn])){
          //     data['fileURL'] = this.currentDataFile.find(x => x.id == data[this.idColumn]).fileUrl;
          //   }
          //   else{
          //     this.attachmentService.downloadFile(data[column.PropertyName].split('|')[0]).subscribe(result=>{
          //       data['fileURL'] = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(result));
          //       this.currentDataFile.push({id: data[this.idColumn], fileUrl: data['fileURL']});
          //     });
          //   }
          // }
        }
        else if (column.ViewColumnType == "FILEUPLOAD"){
          // if (data[column.PropertyName]){
            this.getFileList(data, column);
          // }
        }
        else if (column.ViewColumnType){
          if (column.AdditionalParameter){
            if(column.AdditionalParameter.indexOf('Expand') > -1){
              this.isBreakdownSummary = true;
            }
          }
        }
      });
    });

    if (this.summaryData && summaryData){
      this.summaryData.forEach(data => {
        if (data["selected"]){
          var exactData = summaryData.find(x => x[this.idColumn] == data[this.idColumn]);
          if (exactData){
            exactData["selected"] = data["selected"]; 
          }
        }
      });
    }

    this.summaryData = this.sortSummaryData(summaryData);
  }

  log(event){
    console.log(event);
  }

  removeCardLoading(){
    this.fixLoader = false;
    this.isCardBusy = false;
    this.delayUpdateVariable(false);
  }

  delayUpdateVariable(bool:boolean = false){
    setTimeout(() => {
        this.isBusy = bool;
    });
  }

  handleSummarySelection(){

    this.summary.Actions.forEach(action => {
      this.checkButtonDisabled(action);
    });

    if (this.hasActionRequiresSelection){
      this.summary.ShowCheckmark = true;
    }
  }

  sortSummaryActions(){
    this.summary.Actions = this.summary.Actions.sort((a:SummaryActions,b:SummaryActions) => { 
      if(a.ActionOrder > b.ActionOrder){
        return 1;
      }else if(a.ActionOrder < b.ActionOrder){
        return -1;
      }else{
        return 0;
      }
     });
  }

  handleInlineControls(){
    this.isLoadingInline = true;
    this.loopInlineControls(this.summary.Data, 0);
  }

  loopInlineControls(data: any, index:number){
    this.summaryService.selectItem(this.componentId, data[index][this.idColumn]).subscribe(result=>{
      if(result){
        data[index]['detailId'] = result;
        index++;
        if (data.length > index){
          this.loopInlineControls(data, index);
        }
        else{
          this.isLoadingInline = false;
        }
      }
    }, error => {
      this.isLoadingInline = false;
    });
  }

  calcColumnsLength(){
    this.columnsLength = this.visibleColumns.length;
    if (this.summary.SelectionType == 'SINGLE' || this.summary.SelectionType == 'MULTI'){
      this.columnsLength++;
    }
    if (this.summary.ColumnHasSearch){
      this.columnsLength++;
    }
  }
  
  filterByColumn(keyword:any, columnName:string, isMultiValue: boolean = false){
    if (keyword == null) return false;
    if (isMultiValue && keyword.length == 0) {
      keyword = "";
    }else {
      // tie current keyword to column instead
      // if (JSON.stringify(this.filterKeyword) === JSON.stringify(keyword)){
      //   return false;
      // }
    }
    if (isMultiValue && keyword){
      var values: string[] = keyword;
      var newKeyword:string[] = [];
      this.visibleColumns.find(x => x.PropertyName == columnName).FilterValueSelection.forEach(lookup => {
        if (values.findIndex(x => x == lookup.SelectionValue) > -1){
          newKeyword.push(lookup.SelectionDisplay);
        }
      })
      keyword = newKeyword;
    }
    
    this.filterKeyword = keyword;

    this.animate = false;
    this.isBusy = true;
    
    this.summaryService.FilterColumnByValue(this.componentId, columnName, keyword).subscribe(result => {
      if (result == "1"){
        this.isFiltering = true;
        this.animate = true;
        this.isFilteredSummary = true;
        this.isSelectAll = false;
        // if (this.summary.ShowCheckmark)
        // {
        //   this.refreshCard();
        // }
        // else
        // {
        this.refreshCard(false);
        // }
      }
    }, error => {
      this.animate = true;
      this.isBusy = false;
    })
  }

  selectAll(){
    this.isSelectAll = !this.isSelectAll;
    this.markList = [];
    if (this.isSelectAll){
      this.currentSummaryData.forEach(data => {
        this.markList.push(data[this.idColumn]);
        this.getSelectionValues(data);
      });

      this.selectedRowCount = this.summary.TotalRows;
      this.summaryService.checkAllItems(this.componentId).subscribe(result => {
        this.allSelectedIds = JSON.parse(result);
      })
    }
    else{
      this.currentSummaryData.forEach(data => {
        this.getSelectionValues(data);
      });

      this.selectedRowCount = 0;
      this.markList = [];
      this.parentArray = [];
      this.allSelectedIds = [];
      this.summaryService.uncheckAllItems(this.componentId).subscribe(result => {
        //console.log(result);
      })
    }
    
    this.summary.Actions.forEach(action => {
      this.checkButtonDisabled(action);  
    });
    
  }

  onFilterChanged(propertyName: string){
    this.visibleColumns.find(x => x.PropertyName == propertyName).IsFilterChanged = true;
    
  }

  clear(propertyName: string, select:any){
    this.visibleColumns.find(x => x.PropertyName == propertyName).IsFilterChanged = true;
    setTimeout(() => {
      select.focus();
    })
  }

  clearAllFilter(){
    this.animate = false;
    this.isBusy = true;
    this.filterKeyword = null;
    this.summaryService.ClearColumnFilter(this.componentId).subscribe(result => {
      this.animate = true;
      this.isBusy = false;
      this.isFilteredSummary = false;
      this.refreshCard();
    })
  }

  constructObjectByLayout(){
    if (this.summaryLayout == "CARDIMAGE" || this.summaryLayout == "CARDIMAGEDETAIL" || this.summaryLayout == "SUMMARYSUPPLIER" 
    || this.summaryLayout == "CARDIMAGEBASIC" || this.summaryLayout == "CARDOPTION" || this.summaryLayout == "CARDIMAGEWIDE"
    || this.summaryLayout == "CARDOPTIONWIDE"){
      this.populateImage(this.retrieveDataByCardProperty('Image'));
    }
    else if(this.summaryLayout == "CARDBASIC"){
      this.stackCardBasic = []; 
      this.summary.Data.forEach(element => {
        if (element[this.retrieveDataByCardProperty('grp')] != null)
        {
          var i:number = 1;
          var g = this.stackCardBasic.filter(x => x.GroupId == element[this.retrieveDataByCardProperty('grp')]);
          var stackNum = i + g.length;
          if (g.length > 0){
            if(stackNum > 3) stackNum = 4; 
            this.stackCardBasic.find(x => x.GroupId == element[this.retrieveDataByCardProperty('grp')]).Type = 'multi';
            this.stackCardBasic.push({
              StackNo:stackNum, 
              GroupId :element[this.retrieveDataByCardProperty('grp')], 
              Id: element[this.retrieveDataByCardProperty('ID')], 
              Type:'', 
              ToggleNo:1,
              ShowCards:false}
            );
          }
          else{
            this.stackCardBasic.push({
              StackNo:stackNum, 
              GroupId :element[this.retrieveDataByCardProperty('grp')], 
              Id: element[this.retrieveDataByCardProperty('ID')], 
              Type:'', 
              ToggleNo:1,
              ShowCards:false});
          }
        }
      });
    }
    else if(this.summaryLayout == "EDITABLECARD"){
      this.editablecardUrl = [];
      this.summary.Data.forEach(element => {
        this.editablecardUrl.push({
          id: element[this.retrieveDataByCardProperty('ID')],
          imageURL: ''
        })
      })
    }
    else if (this.summaryLayout == "CARDMESSAGES"){
      let timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
      if (this.sub4) this.sub4.unsubscribe();
      this.sub4 = timer.subscribe(t => this.checkIfSummaryHasUpdate(true));
    }
    else if (this.summaryLayout == "CARDINPUT"){
      let timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
      if (this.sub6) this.sub6.unsubscribe();
      //this.sub6 = timer.subscribe(t => this.checkIfSummaryHasUpdate(true));
    }
    else if (this.summaryLayout == "HIERARCHY" || this.summaryLayout == "HIERARCHYVIEW"){
      this.buildTree(this.summary.Data);
    }
    else if (this.summaryLayout == "TABLE"){
      this.calcColumnsLength();
      var imageColumn = this.summary.Columns.find(x => x.ViewColumnType == "IMAGE");
      if(imageColumn){
        this.populateImage(imageColumn.PropertyName);
      }
    }
  }

  populateImage(imageColumnName){
    if (this.summary.Data.length > 0) {
      this.imageObject = [];
      this.imageId = [];
      this.summary.Data.forEach(element => {
        // set the id
        if (element[imageColumnName] != null)
        {
          let docId = element[this.idColumn];
          let array = element[imageColumnName].split(",");
          array.forEach(imageId => {
            if (!imageId){
              imageId = '00000000-0000-0000-0000-000000000000';
            }
            this.imageId.push(imageId);
            this.imageObject.push({docId, imageId});
          });
        }
      });

      this.getAllImage();
      setTimeout(()=>{
        this.isImageLoad = false;
      }, 15000)
    }
  }

  checkmark($event:any, row:any){
    // if (this.isSelectAll) this.isSelectAll = false;
    // store selectedid/s in a list depending on selection type
    if (this.summary.SelectionType == 'SINGLE'){
      if (this.markList[0] == row[this.idColumn]){
        this.markList = [];
      }
      else {
        this.markList[0] = row[this.idColumn];
      }
    }
    else if (this.summary.SelectionType == 'MULTI') {
      if (this.markList.indexOf(row[this.idColumn]) > -1){
        this.selectedRowCount--;
        this.markList.splice(this.markList.indexOf(row[this.idColumn]), 1);
      }
      else {
        this.selectedRowCount++;
        this.markList.push(row[this.idColumn]);
      }
    }
    
    if (this.markList.length == this.summary.TotalRows){
      this.isSelectAll = true;
      this.summaryService.checkAllItems(this.componentId).subscribe(result => {
        this.allSelectedIds = JSON.parse(result);
      })
    }
    else{
      this.isSelectAll = false;
      if (this.selectedRowCount == this.summary.TotalRows) this.isSelectAll = true;
    }

    var param = this.getSelectionValues(row);

    if (this.markList.indexOf(row[this.idColumn]) > -1){
      this.selectedArray.push(row);
      this.summaryService.checkItem(this.componentId, row[this.idColumn], param).subscribe(result => {
        //console.log(result);
        // handle
      });
    }
    else{
      this.selectedArray.splice(this.selectedArray.findIndex(x => x[this.idColumn] == row[this.idColumn]), 1);
      this.summaryService.uncheckItem(this.componentId, row[this.idColumn]).subscribe(result => {
        //console.log(result);
        // handle
      });
    }

    this.summary.Actions.forEach(action => {
      this.checkButtonDisabled(action);  
    });

    // this.summaryService.selectItems(this.componentId, this.markList).subscribe(result=>{
    //   if (result == "1"){
    //     // show loading end
    //   }
    // });
    
    // $event.preventDefault(); 
    // $event.stopPropagation();
  }

  getSelectionValues(row: any): string{
    var param;
    // get selectedvalues for each column in this row, and store in a list => arr
    if (this.summaryLayout == "TABLE"){
      var arr = [];
      if (this.markList.indexOf(row[this.idColumn]) > -1){
        this.summary.Columns.forEach(column => {
          if (column.IsID) {
            arr.push({name: column.PropertyName, value: row[column.PropertyName]});
          }
          if (column.ViewColumnType == 'EDITABLETEXT' || column.ViewColumnType == 'EDITABLEDATE' || column.ViewColumnType == 'COMBOBOX' || column.ViewColumnType == 'MULTICOMBOBOX'){
            arr.push({name: column.PropertyName, value: column.ViewColumnType == 'COMBOBOX' ? row[column.PropertyName] : JSON.stringify(row[column.PropertyName])});
            param = { property: column.PropertyName, value: row[column.PropertyName] };
          }
        });
      }
      else {
        var index = this.parentArray.findIndex(x => x.id == row[this.idColumn]);
        this.parentArray.splice(index, 1);
        if (this.allSelectedIds.find(x => x == row[this.idColumn])){
          this.allSelectedIds.splice(this.allSelectedIds.findIndex(x => x == row[this.idColumn]), 1)
        }
      }
      
      if (arr.length > 0){
        if (this.summary.SelectionType == "SINGLE") this.parentArray = [];
        
        if (this.parentArray.filter(x => x.id == row[this.idColumn]).length == 0){
          this.parentArray.push({id:row[this.idColumn], value: arr});
        }
      }
    }
    return param;
  }

  sortBySummaryColumn(name:string){
    this.isBusy = true;
    this.animate = false;
    this.summaryService.ChangeSummaryTableSorting(this.componentId, name).subscribe(result => {
      if(result == "1"){
        this.emitSelectedId = false;
        this.showNoLoader = true;
        this.refreshCard();
      }
    }, error => {
      this.isBusy = false;
      this.animate = true;
    })
  }

  fetchMore(event: IPageInfo) {
    if (this.summary.CurrentPage == this.summary.AvailablePages || this.isExpandSummary) return;
    if (event.endIndex == this.summaryData.length - 1){
      if (!this.isFetching && !this.isGetSummary) {
          this.isFetching = true;
          this.fetching.emit(true);
          this.fetchNextChunk().then(chunk => {
            this.summaryData = chunk;
            this.currentSummaryData = this.summaryData;
            this.cloneSummaryData = JSON.parse(JSON.stringify(this.summaryData));
            this.storeIfSelectAll();  
            this.isFetching = false;
            this.fetching.emit(false);
            this.loadMoreImages();
          }, () => this.isFetching = false);
      }
    };
  }

  getNextSummary(){
    this.isLoadingAsync.next(true);
    this.isFetching = true;
    this.fetchNextChunk().then(chunk => {
      this.summaryData = chunk;

      this.currentSummaryData = this.summaryData;

      this.storeIfSelectAll();
      this.loadMoreImages();

      this.nextPageLoaded = true;
      this.isLoadingAsync.next(false);
      this.isFetching = false;
    }, error => {
      this.isLoadingAsync.next(false);
      this.isFetching = false;
    });
  }

  fetchNextChunk(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      if (this.isGetSummary) {
        reject('summary refreshed from other place');
      }
      this.summaryService.nextPage(this.componentId).subscribe(returns => {
        if (returns == "1"){
          this.summaryService.getSummary(this.componentId).subscribe(result=> {
            var summary = JSON.parse(result);
            this.summary.CurrentPage = summary.CurrentPage;
            
            summary = this.handleSummaryImages(summary);
            resolve(summary.Data);
          })
        }
      });
    });
  }

  handleSummaryImages(summary: Summary){
    if (summary.Data.length > 0) {
      this.nextImageObject = [];
      this.nextImageId = [];
      summary.Data.forEach(element => {
        // set the id
        if (element[this.retrieveDataByCardProperty('Image')] != null)
        {
          let docId = element[this.retrieveDataByCardProperty('ID')];
          let array = element[this.retrieveDataByCardProperty('Image')].split(",");
          array.forEach(imageId => {
            if (!imageId){
              imageId = '00000000-0000-0000-0000-000000000000';
            }

            if (this.imageId.indexOf(imageId) > -1){
              this.imageId.push(imageId);
              this.imageObject.push({docId, imageId});
            }
            else{
              this.nextImageId.push(imageId);
              this.nextImageObject.push({docId, imageId});
            }
          });
        }
      });
    }

    summary.Data = this.sortSummaryData(summary.Data);
    summary.Data = this.parseValueForMultiCombobox(summary, summary.Data);
    return summary;
  }

  // performance experimental fix
  loadMoreImages(){
    if (this.nextImageObject){
      if (this.nextImageId.length > 0) {
        // this.isImageLoad = true;
        this.promiseNextImage(this.nextImageId, this.nextImageObject).then(chunk => {
          this.currentCardImage = chunk;
          this.summary.CardImageList = chunk;
        });
      }
    }
  }

  promiseNextImage(imageIds: any, imageObject: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      var list = this.currentCardImage;
      this.summaryService.getAllImage(imageIds).subscribe(results => {
        var index = 0;
        for(let result of results) {
          result = new Blob([result], {type: 'image/jpg'});
          let docId = imageObject.find(x => x.imageId == imageIds[index]).docId;
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            list.push({
              DocumentId : docId,
              ImageId : imageIds[index],
              Blob : reader.result
            });

          }, false);

          this.imageId.push(imageIds[index]);

          if (result) {
            reader.readAsDataURL(result);
          }
          index++;
        }
      });
      
      resolve(list);
    });
  }

  parseValueForMultiCombobox(summary: Summary, summaryData: any): any{
    var columnName = ""; // for now its working for only one multicombobox per row

    // get columnName for multicombobox
    summary.Columns.forEach(column => {
      if (column.ViewColumnType == "MULTICOMBOBOX"){
        columnName = column.PropertyName;
      }  
    });

    if (columnName){
      // change type of the data to be an array
      this.selectedArray.forEach(row => {
        if (summaryData.find(x => x[this.idColumn] == row[this.idColumn])){
          if(summaryData.find(x => x[this.idColumn] == row[this.idColumn])[columnName]){
            summaryData.find(x => x[this.idColumn] == row[this.idColumn])[columnName] = JSON.parse(summaryData.find(x => x[this.idColumn] == row[this.idColumn])[columnName]);
          }
        }
      });
    }
    
    return summaryData;
  }

  getNestedChildren(arr, parent) {
    var out = []
    for(var i in arr) {
      if(arr[i].parent == parent) {
        var children = this.getNestedChildren(arr, arr[i].id)

        if(children.length) {
          arr[i].children = children
        }
        out.push(arr[i])
      }
    }
    return out
  }

  getFilteredList(array, key, value) {
    return array.filter(function (o) {
        return o[key] == value;
    });
  } 

  getStack(id:any):any{
    var stack:any = 1;
    if(!id) return false;
    if(this.stackCardBasic.find(x =>x.Id == id))
    stack = this.stackCardBasic.find(x=> x.Id == id).StackNo;
    return stack;
  }

  getMulti(id:any):boolean{
    var isMulti = false;
    if(!id) return false;
    if(this.stackCardBasic.find(x =>x.Id == id)){
      if (this.stackCardBasic.find(x=> x.Id == id).Type == 'multi'){
        isMulti = true;
      }
    }
    return isMulti;
  }

  toggleStack(groupId:string, event){
    if(this.stackCardBasic.find(x =>x.GroupId == groupId)){
      this.stackCardBasic.filter(x=>x.GroupId == groupId).forEach(card => {
        var cardNo = card.StackNo;
        var cardToggle = card.ToggleNo;
        card.ToggleNo = cardNo;
        card.StackNo = cardToggle;
      });
      this.stackCardBasic.find(x=>x.GroupId == groupId).ShowCards = !this.stackCardBasic.find(x=>x.GroupId == groupId).ShowCards;
    }
    event.stopPropagation();
  }

  openCombobox(isFilter:boolean = false){
    if (this.isSummaryPopup || isFilter){
      // if (isFilter) this.virtualScroller.invalidateAllCachedMeasurements();
      document.querySelectorAll("body").item(0).style.position = "relative";
    }
  }

  closeCombobox(isFilter:boolean = false){
    if (this.isSummaryPopup || isFilter){
      document.querySelectorAll("body").item(0).style.position = "initial";
    }
  }

  getShowCards(id:string):boolean{
    if(!this.stackCardBasic.find(x => x.Id == id)) return false;
    return this.stackCardBasic.find(x=>x.Id == id).ShowCards;
  }

  getStackItemsCount(groupId:string){
    if (this.stackCardBasic.filter(x => x.GroupId == groupId).length < 2){
      return "";
    }else{
      var itemCount = this.stackCardBasic.filter(x => x.GroupId == groupId).length - 1;
      if (itemCount == 1) {
        return itemCount + " more item"
      }
      else {
        return itemCount +  " more items";
      }
    }
  }

  getVisibleColumns(){
    this.visibleColumns = this.summary.Columns.filter(x=> !x.PropertyIsHidden).sort((a:SummaryColumn,b:SummaryColumn) => {
      if(a.PropertyOrder > b.PropertyOrder){
        return 1;
      }else if(a.PropertyOrder < b.PropertyOrder){
        return -1;
      }else{
        return 0;
      }
    });

    this.visibleColumns.forEach(column => {
      if (column.AdditionalParameter == "lookup"){
        if (column.ColumnFilterString){
          var array = JSON.parse(column.ColumnFilterString);
          column.ColumnFilterArray = [];
          if (column.FilterValueSelection){
            if (array){
              array.forEach(element => {
                column.ColumnFilterArray.push(column.FilterValueSelection.find(x => x.SelectionValue == element).SelectionDisplay);
              });
            }
          }
          // column.ColumnFilterArray = JSON.parse(column.ColumnFilterString);
          if (!column.FilterValueSelection){
            this.getFilterDropdownList(column.PropertyName);
          }
        }
        else{
          column.ColumnFilterString = null;
        }
      }
    })
    this.visibleColumnNames = this.visibleColumns.map(x => x.PropertyName);

    if (this.summary.ShowCheckmark){
      this.visibleColumnNames.unshift("#RowNumber");
    }
    // if (this.summary.ColumnHasSearch){
    //   this.visibleColumnNames.push("#Clear");
    // }

    // this.summaryData.forEach(data => {
    //   data["#Clear"] = "";
    // });

    if (this.visibleColumns.find(x => x.ColumnIsSorted)){
      this.activeSort = this.visibleColumns.find(x => x.ColumnIsSorted).PropertyName;
      this.activeSortDirection = this.visibleColumns.find(x => x.ColumnIsSorted).ColumnSortIsAsc ? 'asc' : 'desc';
    }
  }

  colTrackBy(index, item) { return item.PropertyName; }

  sortSummaryData(summaryData): any{
    return summaryData.sort((a:any,b:any) => { 
      if(parseInt(a["#RowNumber"]) > parseInt(b["#RowNumber"])){
        return 1;
      }else if(parseInt(a["#RowNumber"]) < parseInt(b["#RowNumber"])){
        return -1;
      }else{
        return 0;
      }
     });
  }

  sortSummaryFunctions(){
    this.summary.Functions = this.summary.Functions.sort((a:SummaryFunctions,b:SummaryFunctions) => { 
      if(a.ActionSequence > b.ActionSequence){
        return 1;
      }else if(a.ActionSequence < b.ActionSequence){
        return -1;
      }else{
        return 0;
      }
     });
  } 

  handleSummaryFunctions(){
    if (this.summary.Functions) {
      var summaryFunctions = this.summary.Functions.filter(x => x.ActionType != "ACTIONSAVE");
      if (summaryFunctions.length > 0){
        if (this.isFromExpandSummary){
          summaryFunctions = summaryFunctions.filter(x => x.ActionType != "EXPAND");
        }
        this.sortSummaryFunctions();
        this.actions = summaryFunctions;
        
        if (summaryFunctions.length == 1){
          this.showSummaryMenu = true;
          if (summaryFunctions[0].ActionSequence == 0){
            this.showSummaryMenu = false;
          }
        }
        else{
          this.showSummaryMenu = true;
        }
        this.showSummarySettings.emit(true);
      }
      else {
        this.showSummaryMenu = false;
        this.showSummarySettings.emit(false);
      }
    }
    else{
      this.showSummaryMenu = false;
      this.showSummarySettings.emit(false);
    }
  }

  handleActionSave(){
    if (this.summary.Functions){
      this.summary.Functions.filter(x => x.ActionType == "ACTIONSAVE").forEach(fn => {
        var action = this.summary.Actions.find(x => x.ActionCommand == fn.ActionParameter);
        if (action){
          this.actionSaveDisplay = fn.ActionDisplay;
          action.IsHidden = true;
        }
      })
    }
  }

  handleHeaderAndFooter(){
    if (this.summary.FooterText){
      if (this.summary.FooterText.indexOf("{") > -1){
        this.summary.FooterHasButton = true;
        var re = new RegExp(/{(.*?)}/); // get string inside curly bracket
        var reString = re.exec(this.summary.FooterText);
        
        if (reString){
          if (reString.length > 0){
            var displayValue = reString[1].split('|')[0];
            this.footerButton = this.summary.Actions.find(x => x.ActionName == reString[1].split('|')[1]);
            if (this.footerButton){
              this.footerButton.IsHidden = true;
              this.summary.FooterText = this.summary.FooterText.replace(re, "<span class='footer-button'>" + displayValue + "</span>");
              
              setTimeout(() => {
                if (this.elRef.nativeElement.querySelector('.footer-button')){
                  if (this.footerBtnInstance) {
                    this.footerBtnInstance();
                  }
                  this.footerBtnInstance = this.renderer.listen(this.elRef.nativeElement.querySelector('.footer-button'), 'click', () => {
                    this.performAction('', this.footerButton.ActionCommand, this.footerButton);
                  });
                }
              })
            }
          }
        }
      }
      else if (this.summary.FooterText.indexOf("=") > -1){
        var re = new RegExp(/=([^\s]+)/g); // get string after equal sign, before whitespace

        var matches = this.summary.FooterText.match(/=([^\s]+)/g);

        if (matches){
          matches.forEach(match => {
            const text = match;
            var phrase = match.replace("=", "");

            var total = 0;
            var operator = "add";
            var secColumnName;
            var columnName = phrase.split('|')[0];
            var formatString = phrase.split('|')[1];

            if (columnName.split('*')[1]) {
              secColumnName = columnName.split('*')[1];
              columnName = columnName.split('*')[0];
              operator = "multiply";
            }
            else if (columnName.split('-')[1]) {
              secColumnName = columnName.split('-')[1];
              columnName = columnName.split('-')[0];
              operator = "substract";
            }
            else if (columnName.split('/')[1]){
              secColumnName = columnName.split('/')[1];
              columnName = columnName.split('/')[0];
              operator = "division";
            }

            total = this.getTotalClientCalculation(columnName, secColumnName, operator, total);

            if (formatString){
              this.workspaceService.convertToDecimal(total.toString(), formatString).subscribe(result => {
                this.summary.FooterText = this.summary.FooterText.replace(text, "<span class='client-calc' data-column='" + columnName 
                + "' data-seccolumn='" + secColumnName + "' data-format='" + formatString + "' data-operator='" + operator + "'>" + result + "</span>");
              })
            }
            else{
              this.summary.FooterText = this.summary.FooterText.replace(text, "<span class='client-calc' data-column='" + columnName 
              + "' data-seccolumn='" + secColumnName + "' data-format='" + formatString + "' data-operator='" + operator + "'>" + total + "</span>");
            }

          });
        }
      }
    }
  }

  retrieveDataByCardProperty(cardProperty: string): string {
    if (this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty) != null){
      return this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).PropertyName;
    }
  }

  retrieveColumnTypeByCardProperty(cardProperty: string): string {
    if (this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty) != null){
      return this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).PropertyColumnType;
    }
  }

  retrieveColParamByCardProperty(cardProperty: string): string {
    if (this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty) != null){
      return this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).ColumnParameter;
    }
  }

  retrieveFormatByCardProperty(cardProperty: string): string {
    if (this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty) != null){
      return this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).PropertyFormat;
    }
  }

  getLink(url: string):SafeUrl{
    var newUrl = "//" + url;
    return this.sanitizer.bypassSecurityTrustUrl(newUrl);
  }
  
  getIndicatorColor(data: any):string {
    this.indicatorColor = this.loaderConfig.primaryColour;
    if (this.summaryLayout == "CARDSTANDARDSTATUS"){
      if (data == "GOOD"){
        this.indicatorColor = "#64A338";
      }
      else if (data == "BAD"){
        this.indicatorColor = "#f89406";
      }
    }
    else {
      if (data == 0){
        this.indicatorColor = "#f89406";
      }
    }
    return this.indicatorColor;
  }

  openDetail(docInstanceId: string) {
    if (!this.isBusy){
      this.isBusy = true;
      this.animate = false;
      this.summaryService.selectItem(this.componentId, docInstanceId).subscribe(result=>{
        this.handleWorkflowReturn(result);
        this.isBusy = false;
        this.animate = true;
      });
    }
  }

  setCurrentImage(image: Blob){
    this.currentImage = image;
  }

  createImageFromBlob(docId, imageId : string, image: Blob, list: any) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.summary.CardImageList.push({
        DocumentId : docId,
        ImageId : imageId,
        Blob : reader.result
      });

    }, false);
 
    if (image) {
       reader.readAsDataURL(image);
    }
  }

  getFirstImage(id : string): any {
    if (this.summary.CardImageList != null) {
      if (this.summary.CardImageList.find(x => x.DocumentId == id) != null){
        if(this.summary.CardImageList.find(x => x.DocumentId == id).Blob){
          return this.summary.CardImageList.find(x => x.DocumentId == id).Blob;
        }
        else {
          return null;
        }
      }
    }
  }

  setDisplayedImage(){

  }

  getCardImage(id : string): any {
    let array = [];
      if (this.summary.CardImageList != null) {
        if (this.summary.CardImageList.find(x => x.DocumentId == id) != null){
          this.summary.CardImageList.filter(x => x.DocumentId == id).forEach(element => {
            array.push(element.Blob);
          });
          if (!this.currentImage){
            if(array.length > 0){
              this.currentImage = array[0];
            }
          }
        }
      }
    return array;
    
  }

  getAllImage() {
    if (this.imageObject){
      if (this.imageId.length > 0) {
        this.isImageLoad = true;
        this.promiseImage(this.imageId).then(chunk => {
          this.currentCardImage = chunk;
          this.summary.CardImageList = chunk;
        });
      }
    }
  }

  promiseImage(imageIds: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      var list = [];
      this.summaryService.getAllImage(this.imageId).subscribe(results => {
        var index = 0;
        for(let result of results) {
          result = new Blob([result], {type: 'image/jpg'});
          let docId = this.imageObject.find(x => x.imageId == this.imageId[index]).docId;
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            list.push({
              DocumentId : docId,
              ImageId : this.imageId[index],
              Blob : reader.result
            });

          }, false);
      
          if (result) {
            reader.readAsDataURL(result);
          }
          index++;
        }

        setTimeout(()=>{
          this.isImageLoad = false;
        }, 100)
        
      });
      resolve(list);
    });
  }

  performAction(selectedItemId: string, actionCommand: string, action: any, customParam: any = null){
    this.isBusy = true;
    this.animate = false;
    if(selectedItemId){
      actionCommand = actionCommand.split(':')[1].replace("}", "");
      this.summaryService.summaryItem(this.componentId, selectedItemId, "", actionCommand).subscribe(result => {
        this.handleWorkflowReturn(result);
      });
    }
    else{
      var param:any;
      if (this.summary.SelectionType == 'SINGLE' || this.summary.SelectionType == 'MULTI'){
        param = [];
        param = this.markList;
        if (this.summaryLayout == "TABLE"){  
          if (this.parentArray.length > 0){
            this.allSelectedIds.forEach(id => {
              if (this.parentArray.findIndex(x => x.id == id) < 0){
                var arr = [];
                arr.push({name: this.idColumn, value: id});
                this.parentArray.push({id: id, value: arr});
              }
            });
          }
          else{
            this.allSelectedIds.forEach(id => {
              var arr = [];
              arr.push({name: this.idColumn, value: id});
              this.parentArray.push({id: id, value: arr});
            });
          }
          
          param = this.parentArray.map(a => a.value); // list of list of mbsparameterobjects
        }
      }
      else if (this.summary.CellSelectionType == 'SINGLE'){
        param = [];
        var arr = [];
        var newCellsSelected = [];

        this.cellsSelected.forEach(cell => {
          newCellsSelected.push(cell.value);
        });
        
        arr.push({name: this.cellsSelected[0].name, value: JSON.stringify(newCellsSelected)});
        param.push(arr);
      }
      else {
        param = "";
      }

      if (customParam) param = customParam;
      if (action) {
        this.isBusy = false;
        this.handlePrompt(action, param);
      }
      else {
        this.isBusy = true;
        this.summaryAction(actionCommand, param)
      }
    }
  }

  expandSummary(row: any, parameter: string){
    var param = parameter.replace('{', '').replace('}', '');
    var cleanParam = param.split(this.separator);
    this.isExpandSummary = true;

    var dataColumn = this.summary.Columns.find(x => x.ViewColumnType == "DATA");
    var docId = "";
    if (dataColumn){
      if (row[dataColumn.PropertyName]){
        docId = row[dataColumn.PropertyName];
      }
    }

    if (row['summaryBreakdown']){
      row['summaryBreakdownExpand'] = !row['summaryBreakdownExpand'];
    }else{
      row['isExpanding'] = true;
      this.isBusy = true;
      this.animate = false;
      this.summaryService.getSummaryBreakdownFromSummary(row[this.idColumn], cleanParam[1], cleanParam[2], docId).subscribe(result => {
        if (result){
          row['summaryBreakdown'] = result;
        }
        row['summaryBreakdownExpand'] = true;
        row['isExpanding'] = false;
        this.isBusy = false;
        this.animate = true;
      }, error => {
        row['isExpanding'] = true;
        this.isBusy = false;
        this.animate = true;
      })
    }
  }

  performRowAction(selectedItemId: string, command: string){
    if (command.split(':')[1]){
      var actionCommand = command.split(':')[1].replace("}", "");
      if (this.summary.RowActions.filter(x => x.ActionCommand == actionCommand).length > 0){
        var action = this.summary.RowActions.find(x => x.ActionCommand == actionCommand);
        if (action.TriggersPrompt){
          switch(action.PromptType){
            case "Yes|No":
              this.summaryService.getConfirmationMessage(this.componentId, selectedItemId, action.ActionCommand).subscribe(result => {
                if (result){
                  this.confirmationService.confirm(
                    "Confirmation",
                    result,
                    ["CANCEL", "OK"])
                    .subscribe((respond) => {
                      if (respond.answer == "OK"){
                        this.isBusy = true;
                        this.animate = false;
                        this.summaryItemAction(selectedItemId, action.ActionCommand);
                      }
                      else {
                        this.isBusy = false;
                      }
                    });
                }
              })
            break;
            case "TypeToConfirm":
            this.confirmationService.confirm(
              action.PromptMessage.split('|')[0],
              "",
              ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
              .subscribe((respond) => {
                if (respond.answer == "OK"){
                  this.isBusy = true;
                  this.animate = false;
                  this.summaryItemAction(selectedItemId, action.ActionCommand);
                }
                else {
                  this.isBusy = false;
                }
              });
              break;
          }
        }
        else {
          this.isBusy = true;
          this.animate = false;
          this.summaryItemAction(selectedItemId, action.ActionCommand);
        }
      }
    }
  }

  summaryAction(actionCommand: string, param:any){
    this.isBusy = true;
    this.animate = false;
    this.summaryService.summaryAction(this.componentId, param, actionCommand).subscribe(result => {
      this.handleWorkflowReturn(result);
    }, error => {
      this.animate = true;
      this.isBusy = false;
    });
  }

  summaryItemAction(selectedItemId:string, actionCommand: string){
    this.showNoLoader = true;
    this.summaryService.summaryItem(this.componentId, selectedItemId, "", actionCommand).subscribe(result => {
      this.handleWorkflowReturn(result);
    });
  }

  handlePrompt(action:any, param:any){
    if (action.TriggersPrompt){
      switch(action.PromptType){
        case "Yes|No":
        this.confirmationService.confirm(
          "Confirmation",
          action.PromptMessage,
          ["CANCEL", "OK"])
          .subscribe((respond) => {
            if (respond.answer == "OK"){
              this.summaryAction(action.ActionCommand, param);
            }
          });
        break;
        case "TypeToConfirm":
        this.confirmationService.confirm(
          action.PromptMessage.split('|')[0],
          "",
          ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
          .subscribe((respond) => {
            if (respond.answer == "OK"){
              this.summaryAction(action.ActionCommand, param);
            }
          });
          break;
      }
    }
    else {
      this.summaryAction(action.ActionCommand, param);
    }
  }

  actionOnCard(qty: any, selectedItemId: string, actionName: string, departmentId: string = "", currentPage: number) {
    this.isBusy = true;
    var param = [];
    param.push({ name: 'input_quantity', value: qty });
    param.push({ name: 'selectedItemId', value: selectedItemId });
    param.push({ name: 'departmentId', value: departmentId });
    this.animate = false;
    this.summaryService.summaryItem(this.componentId, selectedItemId, param, actionName).subscribe(result => {
      this.handleWorkflowReturnCurrentPage(result, false, currentPage);
    });
  }

  actionOnCardWithoutParam(selectedItemId: string, actionName: string){
    this.isCardBusy = true;
    this.summaryService.summaryItem(this.componentId, selectedItemId, "", actionName).subscribe(result => {
      this.handleWorkflowReturn(result);
      this.isCardBusy = false;
    }, error => {
      this.isCardBusy = false
    });
  }

  selectCell(column, row){
    // need to change the checking once the indicator for cell selectable is there 
    // ie: set selected value for all data on initial load, avoid additional checking here
    // get all the selected cells by checking each summary data and find the selected column name to find its data
    if (this.summary.CellSelectionType == "SINGLE" || this.summary.CellSelectionType == "MULTI"){
      var value = this.summaryData.find(x => x["#RowNumber"] == row["#RowNumber"]);

      if (this.cellsSelected.findIndex(z => z.name == column.PropertyName) == -1){
        this.cellsSelected = [];
        this.summaryData.forEach(data => {
          data['selected'] = [];
        });
      }
  
      if (value){
        if (value['selected']){
          if (value['selected'].length > 0){
            if (value['selected'].findIndex(y => y == column.PropertyName) > -1){
              var index = value['selected'].indexOf(column.PropertyName);
              if (index !== -1) value['selected'].splice(index, 1);
            }
            else{
              value['selected'].push(column.PropertyName);
            }
          }
          else{
            value['selected'] = [column.PropertyName];
          }
        }
        else{
          value['selected'] = [column.PropertyName];
        }
  
        // unselect
        var exists = this.cellsSelected.findIndex(z => z.index == row["#RowNumber"]);
        
        if (exists > -1){
          this.cellsSelected.splice(exists, 1);
        }
        else {
          var selected = { "index" : row["#RowNumber"], "name" : column.PropertyName, "value" : row[column.PropertyName]};
          this.cellsSelected.push(selected);
        }
        
        this.summary.Columns.forEach(column => {
          column.CellsSelected = 0;
          this.summaryData.forEach(data => {
            var index = -1;
            if (data['selected']){
              index = data['selected'].indexOf(column.PropertyName);
            }
             
            if (index > -1) column.CellsSelected++;
          });
        });
      }
    }
    this.summary.Actions.forEach(action => {
      this.checkButtonDisabled(action);
    });
  }

  removeDuplicatesBy(comparator, array) {
    var length = array.length;
    var unique = [];

    for (var i = 0; i < length; i++) {
        var element = array[i];
        var isUnique = true;

        for (var j = 0; j < i; j++) {
            if (comparator(element, array[j])) {
                isUnique = false;
                break;
            }
        }

        if (isUnique) unique.push(element);
    }

    return unique;
}

  getBoolean(any:any){
    var bool:boolean;
    if(any){
      if(any == true || any == 'True' || any == 'true'){
        bool = true;
      }
      else{
        bool = false;
      }
    }
    else{
      bool = false;
    }
    return bool;
  }

  isFloat(value) {
    return /^(\d{1,})(,\d{1,})*(\.\d{1,})?$/.test(value);
}

  saveLineChange(data, column, qty: string, actionName, departmentId: string = "") {
    var cleanedValue = qty;
    if (!Array.isArray(qty)){
      if(this.isFloat(qty.replace(/,/g, ""))){
        cleanedValue = qty.replace(/,/g,"");
      }
    }
    
    var array = [];
    array.push({ name: 'input_quantity', value: cleanedValue });
    array.push({ name: 'selectedItemId', value: data[this.idColumn] });
    array.push({ name: 'departmentId', value: departmentId });

    const index = this.rowsToUpdate.findIndex(x => x.id == data[this.idColumn] + column.PropertyName);

    if (index > -1) {
      this.rowsToUpdate.splice(index, 1);
    }
    
    var param = [
      { name: "id", value: data[this.idColumn] },
      { name: "action", value: actionName },
      { name: "param", value: JSON.stringify(array)}
    ]

    this.rowsToUpdate.push({
      id: data[this.idColumn] + column.PropertyName,
      value: param
    });
  }

  handleWorkflowReturn(result: any, noEmit: boolean = false): any {
    var command = JSON.parse(result);
    this.workflowReturnService.handleWorkflowReturn(command, false);

    if (command.ReturnType != 10 && (command.RefreshType == "self" || command.RefreshType == "none" || !command.RefreshType)){
      this.animate = true;
      this.isBusy = false;
    }

    //web content
    if (command.ReturnType == 13){
      this.emitSelectedItem(command.Arguments[0]);
    }

    if (!noEmit){
      switch(command.ReturnType){
        case 3:
          this.emitSelectedItem(command.Arguments[0]);
          this.selectedItemId = command.Arguments[0];
          break;
        case 4: //message
          if (command.Arguments[2]){
            this.emitSelectedItem(command.Arguments[0]);
            this.selectedItemId = command.Arguments[0];
          }
          break;
      }
    }
    
    switch(command.RefreshType){
      case "self": 
        this.emitSelectedId = false;
        this.refreshCard(); 
      break;
      case "parent": 
        this.isBusy = true;
        this.refreshCard();
        this.getEPICParent(false, command.ReturnType);
      break;
      case "all":
        this.refreshCard();
        this.getEPICParent(true, command.ReturnType);
      break;
    }
  }

  handleWorkflowReturnCurrentPage(result: any, noEmit: boolean = false, currentPage: number): any {
    var command = JSON.parse(result);
    this.workflowReturnService.handleWorkflowReturn(command, false);

    if (command.ReturnType != 10 && (command.RefreshType == "self" || command.RefreshType == "none" || !command.RefreshType)){
      this.animate = true;
      this.isBusy = false;
    }

    //web content
    if (command.ReturnType == 13){
      this.emitSelectedItem(command.Arguments[0]);
    }

    if (!noEmit){
      switch(command.ReturnType){
        case 3:
          this.emitSelectedItem(command.Arguments[0]);
          this.selectedItemId = command.Arguments[0];
          break;
        case 4: //message
          if (command.Arguments[2]){
            this.emitSelectedItem(command.Arguments[0]);
            this.selectedItemId = command.Arguments[0];
          }
          break;
      }
    }
    
    switch(command.RefreshType){
      case "self": 
        this.emitSelectedId = false;
        this.refreshCardCurrentPage(true, currentPage); 
      break;
      case "parent": 
        this.isBusy = true;
        this.refreshCardCurrentPage(true, currentPage);
        this.getEPICParent(false, command.ReturnType);
      break;
      case "all":
        this.refreshCardCurrentPage(true, currentPage);
        this.getEPICParent(true, command.ReturnType);
      break;
    }
  }

  getEPICParent(findAllParent:boolean, returnType:number){
    if (findAllParent){
      this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(result => {
        this.handlePopup(returnType);
        if (result){
          var array = JSON.parse(result);
          array.forEach(id => {
            this.workspaceService.setParentId(id);
          });
        }
      }, error => {
        this.handlePopup(returnType);
      })
    }
    else{
      this.workspaceService.getParentEPICId(this.componentId).subscribe(result => {
        this.workspaceService.setParentId(result);
        this.handlePopup(returnType);
      }, error => {
        this.handlePopup(returnType);
      })
    }
  }

  handlePopup(returnType){
    if (returnType == 4){
      this.hidePopup.emit(true);
    }
  }

  hidesAllModals(){
    for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
      this.modalService.hide(i);
    }
    document.body.classList.remove('modal-open');
    this.sidePopupService.removePopup();
  }

  handleNavigateAndMessage(command:any, hasSession:boolean = false){
    var path = [];
    var newArgs = command.Arguments.splice(2);
    newArgs.forEach(element => {
      path.push(element);
    });
    
    if (hasSession){
      // close all popups
      for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
        this.modalService.hide(i);
      }
      document.body.classList.remove("modal-open");

      this.router.navigate(path);
      this.headerService.setSelectedMenu('clearSelected');
      this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
    }
  }

  openDetailPopup(event, title: string) {
    const initialState = {
      componentId: event,
      title: title
    };

    const config: ModalOptions = {
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-dialog-centered modal-detail',
      initialState: {
        componentId: event,
        title: title
      }
    };

    if (this.modalService.getModalsCount() > 0){
      document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
    }

    this.modalService.onHide.subscribe((reason: string) => {
      if (this.modalService.getModalsCount() > 0){
        document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.add('show');
      }
    })

    this.modalRef = this.modalService.show(DetailPopupComponent, config);
  }

  downloadFile(blob: any, fileName: string): void {
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

  toggleImageFav() {
    this.isFav = !this.isFav;
  }

  viewProductDetail(id: string){
    if(this.parentType){
      this.emitSelectedItem(id);
      this.selectedItemId = id;
    }else{
      this.selectedItemId = id;
      this.isBusy = true;
      this.animate = false;
      this.summaryService.selectItem(this.componentId, id).subscribe(result => {
        this.handleWorkflowReturn(result);
        this.isBusy = false;
        this.animate = true;
      }, error => {
        this.isBusy = false;
        this.animate = true;
      });
    }
  }

  emitSelectedItem(result: any){
    this.subSelectedId.emit(result);
    this.popupSelectedId.emit(result); //if the parent is popup
  }

  clientCalculation(){
    if (this.elRef.nativeElement.querySelectorAll('.client-calc').length > 0){
      this.elRef.nativeElement.querySelectorAll('.client-calc').forEach(element => {
        const el = element;
        const columnName = el.dataset.column;  // get from data attr
        const secColumnName = el.dataset.seccolumn;
        const formatString = el.dataset.format;
        const operator = el.dataset.operator;
        var total = 0;

        total = this.getTotalClientCalculation(columnName, secColumnName, operator, total);
        if (formatString){
          if (total){
            this.promiseConvertDecimal(total.toString(), formatString).then(result => {
              el.innerHTML = result;
            })
          }
        }
        else{
          el.innerHTML = total;
        }
      });
    }
  }

  promiseConvertDecimal(total: string, formatString: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.workspaceService.convertToDecimal(total.toString(), formatString).subscribe(result => {
        resolve(result);
      })
    });
  }


  getTotalClientCalculation(columnName: string, secColumnName: string, operator: string, total: number){
    this.summaryData.forEach(element => {
      if (operator == "add"){
        var value = parseFloat(element[columnName].toString().replace(/,/g, ''));
        total = total + value;
      }
      else if (operator == "multiply") {
        var value = parseFloat(element[columnName].toString().toString().replace(/,/g, '')) * parseFloat(element[secColumnName].toString().replace(/,/g, ''));
        total = total + value;
      }
      else if (operator == "substract") {
        var value = parseFloat(element[columnName].toString().replace(/,/g, '')) - parseFloat(element[secColumnName].toString().replace(/,/g, ''));
        total = total + value;
      }
      else if (operator == "division") {
        var value = parseFloat(element[columnName].toString().replace(/,/g, '')) / parseFloat(element[secColumnName].toString().replace(/,/g, ''));
        total = total + value;
      }
    });

    return total;
  }

  formatData(summaryData:any, prop: string, input: any){
    input.errorState = true;
    var propFormat = this.retrieveFormatByCardProperty(prop);
    if (propFormat){
      var format = propFormat.split(':')[1] ? propFormat.split(':')[1] : propFormat;
      this.workspaceService.convertToDecimal(input.value, format).subscribe(result => {
        if (result == "0" && result != summaryData[this.retrieveDataByCardProperty(prop)]){
          // summaryData['error'] = true;
          // set back to its original value
          var originalValue;
          if (summaryData["prev" + this.retrieveDataByCardProperty(prop)]){
            originalValue = summaryData["prev" + this.retrieveDataByCardProperty(prop)];
          }
          else{
            originalValue = this.cloneSummaryData.find(x => x[this.idColumn] == summaryData[this.idColumn])[this.retrieveDataByCardProperty(prop)];
          }
          summaryData[this.retrieveDataByCardProperty(prop)] = originalValue;
        
          this.onCardChangeData(summaryData[this.idColumn], prop, originalValue);
        }
        else{
          // summaryData['error'] = false;
          summaryData["prev" + this.retrieveDataByCardProperty(prop)] = result;
          summaryData[this.retrieveDataByCardProperty(prop)] = result;
        
          this.onCardChangeData(summaryData[this.idColumn], prop, result);
        }
      })
    }
  }

  onCardChangeData(id:string, cardProperty: string, value: string){
    const obj = {id: id, cardProperty: cardProperty, value: value };
    this.rowDataChanged.next(obj);

    var actionCommand;
    var columnName;

    if (this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty) != null){
      actionCommand = this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).ColumnParameter;
      columnName = this.summary.CardLayoutProperties.find(x => x.CardProperty == cardProperty).PropertyName;
    }

    if (actionCommand && columnName){
      
      const index = this.rowsToUpdate.findIndex(x => x.id == id + columnName);
      if (index > -1) {
        this.rowsToUpdate.splice(index, 1);
      }

      // if (this.cloneSummaryData.find(x => x[this.idColumn] == id)[this.retrieveDataByCardProperty(cardProperty)] != value){ // not the same as original value
        var cleanedValue = value;
        if(this.isFloat(value.replace(/,/g, ""))){
          cleanedValue = value.replace(/,/g,"");
        }
        var array = [];
        array.push({ name: 'input_quantity', value: cleanedValue });
  
        var param = [
          { name: "id", value: id },
          { name: "action", value: actionCommand },
          { name: "param", value: JSON.stringify(array)}
        ]
    
        this.rowsToUpdate.push({
          id: id + columnName,
          value: param
        });
      // }
    }
    
  }

  onChangeData(row: string, column: SummaryColumn, value: any, checkboxValue: string) {
    if (column.ViewColumnType == "CHECKBOX"){
      // cannot check selected value from lookup as lookup for summary column is the same for all row

      var array = JSON.parse(row[column.PropertyName]);
      if (array.length > 0){
        var index = array.findIndex(x => x == checkboxValue);
        if (index > -1){
          array.splice(index, 1);
        }
      }
      else{
        var newValue:any = checkboxValue;
        if (!isNaN(+checkboxValue)){
          newValue = +checkboxValue;
        }
        array.push(newValue);
      }
      row[column.PropertyName] = JSON.stringify(array);
      this.handleChangedValue(row, column, row[column.PropertyName]);
    }
    else{
      this.handleChangedValue(row, column, value);
    }
    

    // if (column.ViewColumnType == 'MULTICOMBOBOX'){
    //   this.virtualScroller.invalidateAllCachedMeasurements();
    // }

    if (this.parentArray.findIndex(x => x.id == row[this.idColumn]) != -1){
      this.parentArray.find(x => x.id == row[this.idColumn]).value.forEach(obj => {
        if (obj.name == column.PropertyName){
          if (column.ViewColumnType == 'COMBOBOX'){
            obj.value = row[column.PropertyName];
          }
          else{
            obj.value = JSON.stringify(row[column.PropertyName]);
          }
        }
      });
    }
  }

  handleChangedValue(row, column, value){
    // this.showSaveIcon = row[this.idColumn];
    // this.showSaveIconLabel = column.PropertyName;

    var param;
    param = { property: column.PropertyName, value: row[column.PropertyName] };

    var changeRowValue: boolean = false;
    var actionName = (column.ViewColumnType == "COMBOBOX" || column.ViewColumnType == "MULTICOMBOBOX" || column.ViewColumnType == "CHECKBOX") ? column.AdditionalParameter.split('|')[1] : column.AdditionalParameter;

    if (actionName){
      if (this.cloneSummaryData.find(x => x[this.idColumn] == row[this.idColumn])[column.PropertyName] != row[column.PropertyName]){ // one problem, null and empty is considered different, thus passed this condition
        this.saveLineChange(row, column, value, actionName, row['DepartmentId']);
      }
      else{
        const index = this.rowsToUpdate.findIndex(x => x.id == row[this.idColumn] + column.PropertyName);
        if (index > -1) {
          this.rowsToUpdate.splice(index, 1);
        }
      }
    }
    else{
      changeRowValue = true;
    }

    if (changeRowValue){
      this.summaryService.changeRowValue(this.componentId, row[this.idColumn], param).subscribe(result => {
        //update;
      })
    }
  }

  calculate(summaryData: any, prop: string, value: string, btn: string){
    var formula = summaryData[this.retrieveDataByCardProperty('formula')];
    var data = summaryData[this.retrieveDataByCardProperty(prop)];
    var operator = summaryData[this.retrieveDataByCardProperty(btn)];
    
    if (formula !== null){
      var matches = formula.match(/{(.*?)}/g); // get string with curly braces
      matches.forEach(match => {
        var dataValue = summaryData[match.replace('{', '').replace('}', '')];
        formula = formula.replace(match, dataValue);
      });
      
      var expression = "" + data + operator + formula.replace("=", "");

      var total = eval(expression.replace(/,/g, ""));

      if (eval(total)){
        var propFormat = this.retrieveFormatByCardProperty(prop);
        if (propFormat){
          var format = propFormat.split(':')[1] ? propFormat.split(':')[1] : propFormat;
          this.workspaceService.convertToDecimal(total, format).subscribe(result => {
            summaryData[this.retrieveDataByCardProperty(prop)] = result;
            this.onCardChangeData(summaryData[this.idColumn], prop, result);
          })
        }
        else{
          summaryData[this.retrieveDataByCardProperty(prop)] = total;
          this.onCardChangeData(summaryData[this.idColumn], prop, total);
        }
      }
    }
  }

  saveAllChanges(){
    this.emitSelectedId = false;
    this.isBusy = true;
    this.animate = false;
    this.showNoLoader = true;
    this.summaryService.actionOnAllItem(this.componentId, this.rowsToUpdate.map(x => x.value)).subscribe(result => {
      this.rowsToUpdate = [];
      if (this.summary.Functions){
        if (this.summary.Functions.filter(x => x.ActionType == "ACTIONSAVE").length > 0){
          var parsed = JSON.parse(result);
          if (parsed.ReturnType == 1 && parsed.Arguments[0] != "Info"){
            this.handleWorkflowReturn(result);
          }
          else{
            this.summary.Functions.filter(x => x.ActionType == "ACTIONSAVE").forEach(element => {
              var action = this.summary.Actions.find(x => x.ActionCommand == element.ActionParameter);
              var param = [];
              param.push({name: this.idColumn, value: this.summaryData[0][this.idColumn]});
              var parent = [];
              parent.push(param);
              this.performAction('', action.ActionCommand, action, parent);
            });
          }
        }
        else{
          this.handleWorkflowReturn(result);
        }
      }
      else{
        this.handleWorkflowReturn(result);
      }
    }, error => {
      this.animate = true;
      this.isBusy = false;
    });
  }

  // onClickCombobox(param: string, rowId: any){
  //   if (this.currentSelectedLookupId != rowId){
  //     this.summaryService.getSummaryDropdownList(this.componentId, rowId, param.split('|')[0]).subscribe(result => {
  //       var valueSelection:ValueSelection[] = JSON.parse(result);
  //       this.dropdownList[rowId] = valueSelection;
  //     });
  //     this.currentSelectedLookupId = rowId;
  //   }
  // }

  getFilterDropdownList(propertyName: string){
    if (!this.visibleColumns.find(x => x.PropertyName == propertyName).FilterValueSelection){
      this.summaryService.getSummaryFilterDropdownList(this.componentId, propertyName).subscribe(result => {
        var lookup = JSON.parse(result);
        if (result){
          lookup = this.sortSummaryFilter(lookup);
        }
        this.visibleColumns.find(x => x.PropertyName == propertyName).FilterValueSelection = lookup;

        var array = JSON.parse(this.visibleColumns.find(x => x.PropertyName == propertyName).ColumnFilterString);
        this.visibleColumns.find(x => x.PropertyName == propertyName).ColumnFilterArray = [];
          if (this.visibleColumns.find(x => x.PropertyName == propertyName).FilterValueSelection){
            if (array){
              array.forEach(element => {
                this.visibleColumns.find(x => x.PropertyName == propertyName).ColumnFilterArray.
                push(this.visibleColumns.find(x => x.PropertyName == propertyName).FilterValueSelection.find(x => x.SelectionDisplay == element).SelectionValue);
              });
            }
          }
      });
    }
  }

  sortSummaryFilter(summryFilter): any{
    return summryFilter.sort((a:ValueSelection,b:ValueSelection) => { 
      if(a.SelectionDisplay > b.SelectionDisplay){
        return 1;
      }else if(a.SelectionDisplay < b.SelectionDisplay){
        return -1;
      }else{
        return 0;
      }
     });

  }

  searchHierarchy(filterText: string){
    const cleanedData = this.summary.Data.filter(x => x[this.retrieveDataByCardProperty('prop2')] !== null);
    const filteredItems = cleanedData.filter(x => x[this.retrieveDataByCardProperty('prop2')].toLowerCase().indexOf(filterText.toLowerCase()) > -1);
    this.buildTree(filteredItems, true);
  }

  buildTree(data: any, isFilter: boolean = false){
    var nodes:MyTreeNode[] = [];
    this.treeNodes = [];
    data.forEach(element => {
      nodes.push({
        id: element[this.retrieveDataByCardProperty('ID')], 
        title: element[this.retrieveDataByCardProperty('prop2')], 
        isSelected:false, 
        parent: element[this.retrieveDataByCardProperty('parentId')]})
    });

    if (data.filter(x => x[this.retrieveDataByCardProperty('parentId')] == "00000000-0000-0000-0000-000000000000").length > 0){
      data.forEach(element => {
        if (element[this.retrieveDataByCardProperty('parentId')] == "00000000-0000-0000-0000-000000000000") {
          var tree = this.getNestedChildren(nodes, element[this.retrieveDataByCardProperty('ID')]);
          this.treeNodes.push({
            id: element[this.retrieveDataByCardProperty('ID')], 
            title: element[this.retrieveDataByCardProperty('prop2')] ? element[this.retrieveDataByCardProperty('prop2')] : 'Empty',
            isSelected: false,
            children: tree
          });
        }
      });
    }
    else{
      // need to recursively find the parent
      this.treeNodes = nodes;

      // need idea
    }

    if (this.selectedItemId){
      if (this.treeNodes.find(x => x.id == this.selectedItemId)){
        this.treeNodes.find(x => x.id == this.selectedItemId).isSelected = true;
      }
    }
    
    this.treeControl.dataNodes = this.treeNodes;
    this.treeDataSource.data = this.treeNodes;
  }

  keyupNumber(inputNumber: any, maxLimit: number){
    inputNumber.value = inputNumber.value.replace(/[^\d]/,'');
    if (inputNumber.value == 0) inputNumber.value = '';
  }

  indexChange(event){
    var swiper = this.directiveRef.swiper();

    if (this.directiveRef && !this.indexSet){
      this.indexSet = true;
      this.directiveRef.setIndex(0);
    }
  }

  addNewRemarkForDocument(txtControl: any){
    if (txtControl.value){
      this.isBusy = true;
      this.animate = false;
      this.summaryService.addNewRemark(this.componentId, txtControl.value).subscribe(result => {
        if (result == "1") {
          txtControl.value = "";
          this.refreshCard();
        }
        else{
          this.animate = true;
          this.isBusy = false;
        }
      }, error => {
        this.animate = true;
        this.isBusy = false;
      })
    }
  }

  checkButtonDisabled(action: SummaryActions){
    if (action.RequiresCellSelection){
      if (this.cellsSelected.length > 0){
        action.IsDisabled = false;
      } 
      else{
        action.IsDisabled = true;
      }	
    }  
    else{
      if (action.RequiresSelection){
        if (action.ExactOneSelection){
          if (this.markList.length == 1){
            action.IsDisabled = false;
          }
          else{
            this.hasActionRequiresSelection = true;
            action.IsDisabled = true;
          }
        }
        else{
          if (this.markList.length == 0){
            this.hasActionRequiresSelection = true;
            action.IsDisabled = true;
          }
          else{
            action.IsDisabled = false;
          }
        }
      }
      else{
        action.IsDisabled = false;
      }
    } 
  }

  storeIfSelectAll(){
    if (this.isSelectAll){
      this.selectedRowCount = this.summary.TotalRows;
      this.markList = [];
      this.currentSummaryData.forEach(element => {
        this.markList.push(element[this.idColumn]);
      });
    }
    else{
      if (this.summary.TotalRows == this.markList.length){
        if (this.summary.ShowCheckmark){
          this.selectedRowCount = this.summary.TotalRows;
          this.isSelectAll = true;
          this.summaryService.checkAllItems(this.componentId).subscribe(result => {
            this.allSelectedIds = JSON.parse(result);
          })
        }
      }
    }
  }

  getTotalSelected(){
    if (this.isSelectAll){
      if(this.isFilteredSummary){
        return this.currentSummaryData.length;
      } 
      else{
        return this.summary.TotalRows;
      }
    }
    else{
      return this.selectedRowCount;
    }
  }
  
  ngOnInit() {
    this.loaderConfig = this.themeSettingService.getTheme();

    var separators = [':', ';'];
    this.separator = new RegExp('[' + separators.join('') + ']', 'g');
    this.onGoing = true;

    this.nextPage.pipe(
      debounceTime(100)
    ).subscribe(result => {
      if (!this.isFetching && (this.summary.AvailablePages > this.summary.CurrentPage)){
        this.getNextSummary();
      }
    })

    this.sub3 = this.rowDataChanged.pipe(
      debounceTime(300)
      ).subscribe(result => {
        this.clientCalculation();
      })     
  }

  ngOnChanges(){
    //this.refreshCard();
  }

  ngOnDestroy(): void {
    if (this.sub1) this.sub1.unsubscribe();
    if (this.sub2) this.sub2.unsubscribe();
    if (this.sub3) this.sub3.unsubscribe();
    if (this.sub4) this.sub4.unsubscribe();
    if (this.sub5) this.sub5.unsubscribe();
    if (this.sub6) this.sub6.unsubscribe();
    if (this.footerBtnInstance) {
      this.footerBtnInstance();
    }
  }

  ngAfterViewInit(){
  }

  onInitChartTable(){
    this.summaryService.setChartTable(true);
  }

  onTableInit(){
    if (this.tableContainer && this.isFromExpandSummary){
      if (this.tableContainer.nativeElement.scrollHeight <= this.tableContainer.nativeElement.clientHeight){
        // means no scrollbar
        if (this.summary.CurrentPage < this.summary.AvailablePages){
          // means theres more data, need to get more data
          this.loopGetNextSummary();
        }
      }
    }
  }

  onScrolled(event){
    if (this.summaryLayout == "SUMMARYSUPPLIER" 
        || this.summaryLayout == "TABLE" 
        || this.summaryLayout == "CARDIMAGEWIDE"){
      this.nextPage.next();
    }
  }

  tableScroll(e){
      this.nextPageLoaded = false;
  }
  // onPlaybackChange(event){
  //   console.log(event);
  //   this.summaryData = this.summaryData.slice(0, event.value - 1);
  //   this.summaryData = [].concat(this.summaryData);
  //   this.chartService.setChartRefresh(true);
  // }

  onFileChange(event: any, row: string, column: any){  // documentinstanceactualid, value in column propertyname
    this.errorMessage = null;
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
      this.uploadAttachment(fileList, 0, row, column);
    }
  }

  uploadAttachment(files: FileList, index:number, row: any, column:any, uploadSuccess: boolean = false){
    if (this.allowedFormats.indexOf(files[index].name.split('.').pop().toLowerCase()) > -1 && files[index].name.indexOf(".") > -1) {
      var item = this.summaryData.find(x => x[this.idColumn] == row[this.idColumn]);
      if (files[index].size / 1024 < this.maxFileSizeKb){
        row["isUploading"] = true;        
        //row["isUploadError"] = false;
        this.attachmentService.uploadAttachment(this.componentId, row[this.idColumn], encodeURIComponent(files[index].name), files[index], column.PropertyName).subscribe(result=>{
          if(result){
            index++;
            if (files.length > index){
              this.uploadAttachment(files, index, row[this.idColumn], column, true);
            }
            else{
              this.getFileList(row, column);
              row["isUploading"] = false;
              //row["isUploadError"] = false;
            }
          }
          else{
            this.getFileList(row, column);
            row["isUploading"] = false;
            //row["isUploadError"] = false;
          }
        }, error => {
          row["isUploading"] = false;
          //row["isUploadError"] = true;
          // this.fileControl.nativeElement.value = "";
        });
      }
      else{
        if (uploadSuccess) this.getFileList(row, column);
        row["isUploading"] = false;
        //row["isUploadError"] = true;
        this.handleFileErrorMessage(FileErrorType.INVALID_SIZE);
      }
      
    }
    else{
      if (uploadSuccess) this.getFileList(row, column);
      row["isUploading"] = false;
      //row["isUploadError"] = true;
      this.handleFileErrorMessage(FileErrorType.INVALID_FORMAT);
      
      
    }
  }

  getFilesSettings(){
    this.attachmentService.getMaximumFileUploadSize().subscribe(result => {
      if (result){
        this.maxFileSizeKb = Number(result);
      }
    });

    this.attachmentService.getAllowedFileTypes().subscribe(result => {
      if (result){
        this.allowedFormats = result.split(',');
        this.allowedFormatsString = this.allowedFormats.join(' ');
        var array = [];
        this.allowedFormats.forEach(element => {
          var newEl = "." + element;
          array.push(newEl);
        });
    
        this.acceptFormatString = array.toString();
      }
    })
  }

  getFileList(row: any, column: any){
    if(row[this.idColumn]){
      this.attachmentService.getAttachmentList(this.componentId, row[this.idColumn], column.PropertyName).subscribe(result=> {
        if(result){
          var fileList = JSON.parse(result);
          // this.sortFileList();
          fileList.forEach(file => {
            this.requestDownloadFile(file);
          });

          this.pushFileList(row[this.idColumn], column.PropertyName, fileList);
        }
        row["isUploading"] = false;
        //row["isUploadError"] = false;
      }, error => {
        row["isUploading"] = false;
        //row["isUploadError"] = true;
      });
    }
  }

  handleFileErrorMessage(fileErrorType: FileErrorType){
    switch(fileErrorType){
      case FileErrorType.INVALID_FORMAT:
        this.errorMessage = "File format is not valid";
      break;
      case FileErrorType.INVALID_SIZE: 
        // if (this.attachmentIsMultiple) {
        //   this.errorMessage = "Please make sure each file size does not exceed the maximum file upload size";
        // }
        // else{
          this.errorMessage = "Please make sure the file size does not exceed the maximum file upload size";
        // }
      break;
    }
  }

  requestDownloadFile(file:AttachmentSummary){
    this.attachmentService.downloadFile(file.AttachmentId).subscribe(data=>{
      this.setFileUrl(file, data);
    });
  }

  setFileUrl(file: AttachmentSummary, data: Blob){
    file.AttachmentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data));
  }

  pushFileList(selectedItemId: string, columnName: string, fileList: any){
    var item = this.summaryData.find(x => x[this.idColumn] == selectedItemId);

    var file = {
      id: selectedItemId + columnName,
      fileSummary: fileList
    }

    if (this.summaryFiles.findIndex(x => x.id == selectedItemId + columnName) > -1){
      this.summaryFiles[this.summaryFiles.findIndex(x => x.id == selectedItemId + columnName)] = file;
    }
    else{
      this.summaryFiles.push(file);
    }
  }

  getFileSummary(row: any, column: any){
    if (this.summaryFiles.find(x => x.id == row[this.idColumn] + column.PropertyName)){
      var fileSummary = this.summaryFiles.find(x => x.id == row[this.idColumn] + column.PropertyName).fileSummary;
      if (fileSummary){
        return fileSummary;
      }
      else{
        return [];
      }
    }
    else{
      return [];
    }
  }

  getFileReport(row, column){
    this.isBusy = true;
    this.animate = false;
    this.summaryService.getFileReport(this.componentId, row[this.idColumn]).subscribe(result =>{
      this.isBusy = false;
      this.animate = true;
      this.downloadFileReport(row, column, result);
    }, error => {
      this.isBusy = false;
      this.animate = true;
    })
  } 

  downloadFileReport(row, column, data: Blob){
    var format = row["FileType"] ? row["FileType"] : ".pdf";
    this.workflowReturnService.downloadFile(data, row[column.PropertyName].split('|')[1] + '.' + format);
  }

  public onContextMenu($event, item: any): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
      this.actions = item;
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  summaryFunction(action:SummaryFunctions, exportOption: string){
    this.summaryService.summaryFunction(this.componentId, action.ActionType, exportOption).subscribe(result => {
      this.handleWorkflowReturn(result);
    });
  }

  checkIfSummaryHasUpdate(insertBefore: boolean = false){
    if(this.componentId){
      this.summaryService.checkIfSummaryHasUpdate(this.componentId).subscribe(result=>{
        if(result == "1"){
          if (this.fromBroadcast) this.summaryService.setHasNewMessages(true);
          if (insertBefore && this.fromBroadcast){
            this.summaryService.getSummary(this.componentId).subscribe(result=> {
              if (result){
                var newSummary = JSON.parse(result);
                newSummary.Data.forEach(data => {
                  if (this.summaryData.findIndex(x => x[this.idColumn] == data[this.idColumn]) < 0 ){
                    this.summaryData.unshift(data);
                  }
                });
              }
            });
          }
          else{
            this.showNoLoader = true;
            this.refreshCard(false);
          }
        }
      })
    }
  }

  playSound(){
    var audio = new Audio("assets/sound/inflicted.mp3");
    audio.play();
  }
}